import type { JSX, ReactNode } from 'react';
import type { FeedbackPalette } from '../types.js';

interface CaptureButtonProps {
  palette: FeedbackPalette;
  label: string;
  icon: ReactNode;
  onClick: () => void;
  busy?: boolean;
}

export function CaptureButton({ palette, label, icon, onClick, busy }: CaptureButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      title={label}
      style={{
        flex: 1,
        padding: '10px 8px',
        borderRadius: 8,
        border: `1px solid ${palette.border}`,
        background: 'transparent',
        color: palette.text,
        fontSize: 12,
        fontWeight: 500,
        cursor: busy ? 'wait' : 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
      }}
    >
      {icon}
      {busy ? '…' : label}
    </button>
  );
}
